import styled from "styled-components";

import { FaRegTrashCan } from "react-icons/fa6";
import { useEffect, useMemo, useState } from "react";
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";
import useApi from "../../../hooks/useApi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { useToast } from "../../../contexts/ToastContext";
import Overlay from "../../../Componentes/Overlay";
import { BsExclamationCircle } from "react-icons/bs";

function toDateInputValue(dateString) {
    if (!dateString) return "";
    const s = String(dateString);
    return s.length >= 10 ? s.slice(0, 10) : "";
}

const Container = styled.div`
    width: 100%;
    flex: 1;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`
const Header = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    gap: 10px;
    background-color: #fff;
    margin-bottom: 15px;
    border-radius: 15px;
    padding: 15px;
    box-sizing: border-box;
`
const InfoWrapper = styled.div`
    width: 250px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: #f0f0f0;
    border-radius: 15px;
    p{
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        margin-left: 20px;
    }
    h3 {
        font-size: 12px;
        color: #555;
        margin: 0;
        margin-left: 20px;
    }
`
const TabelaWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #fff;
    border-radius: 15px;
    overflow: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 2;
    }
    tbody {
        tr {
            border-bottom: 1px solid #ccc;
            height: 45px;
            font-size: 14px;
            padding: 0 15px;
            &:nth-child(even) {
                background-color: #fafafa;
            }
            &:hover {
                background-color: #e0f7fa;
            }
        }
    }
`
const LinhaCabecalho = styled.tr`
    height: 45px;
    border-bottom: 2px solid #ccc;
`
const ColunaCabecalho = styled.th`
    width: ${props => props.width || "auto"};
    text-align: left;
    padding: 0 15px;
    color: #242d34;
    font-size: 15px;
`
const TdInput = styled.td`
    padding: 0;
`
const CellInput = styled.input`
    background-color: transparent;
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    font-size: 14px;
    box-sizing: border-box;
    padding: 0 15px;
    &:focus {
        outline: none;
        border: 1px solid #007bff;
        border-color: #007bff;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
    //remover icone de input type date
    &[type="date"]::-webkit-calendar-picker-indicator {
        display: none;
    }
    &[disabled] {
        background-color: transparent;
        border: 1px solid transparent;
    }
`
const ActionWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 15px;
    margin-top: 15px;
`
const ActionButton = styled.button`
    padding: 10px 20px;
    background-color: ${props => props.disabled ? "#ccc" : "#007bff"};
    color: white;
    font-weight: bold;
    font-size: 14px;
    border: none;
    border-radius: 12px;
    cursor: ${props => props.disabled ? "auto" : "pointer"};
    margin: 0;
    &:hover{
        background-color: ${props => props.disabled ? "#ccc" : "#015fa3"};
    }
    transition: .3s;
`
const AddButton = styled.button`
    padding: 10px 20px;
    background-color: #28a745;
    color: white;
    font-weight: bold;
    font-size: 14px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    margin: 0;
    &:hover{
        background-color: #218838;
    }
    transition: .3s;
    align-self: flex-start;
    margin-right: auto;
`
const EditButton = styled.button`
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    font-weight: bold;
    font-size: 12px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    margin: 0;
    &:hover{
        background-color: #015fa3;
    }
    transition: .3s;
    &:disabled {
        background-color: #ccc;
        cursor: auto;
    }
`
const IconeWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
`
const Lixeira = styled(FaRegTrashCan)`
    width: 100%;
    height: 100%;
    color: #c0392b;
    cursor: pointer;
    &:hover {
        color: #e74c3c;
        transform: scale(1.1);
    }
    transition: .3s;
`
const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
const LoadingContainer = styled.div`
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
const BMPendingWarning = styled.div`
    width: 450px;
    background-color: #fff;
    border-radius: 15px;
    margin: auto;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    h3{
        margin: 0;
        font-size: 18px;
        color: #f39c12;
        text-align: center;
    }
    p{
        margin: 0;
        font-size: 14px;
        color: #555;
        text-align: center;
        margin-top: 10px;
    }
    //Criar animação de fade in e fade out para o componente
    animation: fadeIn 0.3s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    @keyframes fadeOut {
        from {
            opacity: 1;
            transform: translateY(0);
        }
        to {
            opacity: 0;
            transform: translateY(-20px);
        }
    }
    // Quando o componente for desmontado, aplicar a animação de fade out
    &.fade-out {
        animation: fadeOut 0.3s ease-in-out forwards;
    }
`
const BMPendingWarningIconWrapper = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 15px;
    background-color: #fde3c6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto auto 15px auto;
`
const BMPendingWarningIcon = styled(BsExclamationCircle)`
    width: 70%;
    height: 70%;
    color: #f39c12;
`
const BMPendingWarningButton = styled.button`
    width: 100%;
    padding: 10px 20px;
    background-color: #f39c12;
    color: white;
    font-weight: bold;
    font-size: 14px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    margin: 20px 0 0 0;
    transition: .3s;
    &:hover{
        background-color: #d35400;
    }
`

const BodyWrapper = () => {

    const { id } = useParams();
    const { notifySuccess, notifyError } = useToast();

    const api = useApi();
    const navigate = useNavigate();

    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [boletins, setBoletins] = useState([]);
    const [originalBoletins, setOriginalBoletins] = useState([]);

    const [numPedido, setNumPedido] = useState("");
    const [valorFaturamento, setValorFaturamento] = useState(0);
    const [valorTotalBM, setValorTotalBM] = useState(0);


    const valorADistribuir = useMemo(() => {

        return valorFaturamento - valorTotalBM;

    }, [valorFaturamento, valorTotalBM]);

    const handleFetchData = async () => {

        setLoading(true);

        try {

            const { data } = await api.get(`/Painel/API/ControleMedicao/GetPrevisaoBoletim/index.php?id=${id}`);

            setNumPedido(data.numPedido);
            setValorFaturamento(data.valorFaturamento);
            setValorTotalBM(data.valorTotalBM);

            setBoletins(data.previsaoBoletim);
            setOriginalBoletins(data.previsaoBoletim);

            return data;

        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            return null;
        } finally {
            setLoading(false);
        }

    }

    const { state } = useLocation();
    const [isBMPending, setIsBMPending] = useState(false);
    const [BMPendingData, setBMPendingData] = useState(null);
    const [BMPendingWarningVisible, setBMPendingWarningVisible] = useState(false);

    useEffect(() => {
        handleFetchData().then((data) => {

            if (!data || !state?.pendingBM) return;

            console.log(state);

            setIsEditing(true);
            setIsBMPending(true);
            setBMPendingData(state.pendingBM);
            setBMPendingWarningVisible(true);

            const pending = state.pendingBM;
            const editingExisting = pending.idBM != null && pending.idBM !== "";

            if (editingExisting) {
                const merged = data.previsaoBoletim.map((item) => {
                    if (String(item.id) !== String(pending.idBM)) return item;
                    return {
                        ...item,
                        num_bm: String(pending.numMedicao ?? item.num_bm),
                        data: toDateInputValue(pending.dataMedicao),
                        valor_medicao: pending.valor
                    };
                });
                setBoletins(merged);
            } else {
                setValorTotalBM((prev) => prev + pending.valor);
            }

        });

    }, [])

    const handleAddBoletim = () => {

        handleStartEditing();

        const newBoletim = {
            id: null,
            idTemp: crypto.randomUUID(),
            numBoletim: "",
            data: "",
            valor_medicao: 0
        }

        setBoletins(prev => [...prev, newBoletim]);

    }

    const handleChange = (e, id) => {

        const { name, value } = e.target;

        setBoletins(prev => prev.map(item => {

            if (item.id === id || item.idTemp === id) {

                let valor = value;

                if (name === "valor_medicao") {

                    valor = parseCentsFromInput(value);

                }

                return {
                    ...item,
                    [name]: valor
                }
            }

            return item;

        }));

    }

    const isDirty = useMemo(() => {

        return JSON.stringify(boletins) !== JSON.stringify(originalBoletins);

    }, [boletins, originalBoletins]);

    const saldoPrevisao = useMemo(() => {

        return valorADistribuir - boletins.reduce((acc, item) => acc + item.valor_medicao, 0);

    }, [valorADistribuir, boletins]);

    const canSave = useMemo(() => {

        //Verificar se o saldo da previsão é igual a zero para habilitar o botão de salvar
        return saldoPrevisao === 0;

    }, [boletins, saldoPrevisao]);

    const handleStartEditing = () => {

        setIsEditing(true);

    }

    const handleCancel = () => {

        if (!isDirty) {

            setIsEditing(false);
            return;

        }

        setBoletins(originalBoletins);
        setIsEditing(false);

    }

    const handleDelete = (id) => {

        // remover boletim da lista de boletins
        setBoletins(prev => prev.filter(item => item.id !== id && item.idTemp !== id));

    }

    const handleSave = async () => {

        try {

            setSaving(true);

            const formData = new FormData();

            formData.append("idPedido", id);
            formData.append("valorADistribuir", valorADistribuir);
            formData.append("boletins", JSON.stringify(boletins));

            if( state && state.pendingBM ){
                formData.append("pendingBM", JSON.stringify(BMPendingData));
            }

            //Enviar arquivos para que o PHP receba os arquivos no $_FILES
            
            if( state && state.arquivos && state.arquivos.length > 0 ){
                
                state.arquivos.forEach(( f, index) => {
                    formData.append(`files[${index}]`, f.file );
                });

            }

            const { data } = await api.post("/Painel/API/ControleMedicao/SavePrevisaoBoletim/", formData);
            console.log( data );

            window.history.replaceState({}, document.title);
            setIsEditing(false);
            setBMPendingData(null);
            setIsBMPending(false);
            handleFetchData();

            navigate("/modulo/controle-medicao/pedidos-compra/");
            notifySuccess("Previsão de boletim salva com sucesso!");

        } catch (e) {

            console.error(e);
            notifyError("Erro ao salvar previsão de boletim. Tente novamente.");

        } finally {

            setSaving(false);

        }

    }

    const [btnConfirmLeaving, setBtnConfirmLeaving] = useState(false);

    const confirmPendingBM = () => {

        setBtnConfirmLeaving(true);
        setTimeout(() => setBMPendingWarningVisible(false), 300);

    }

    return (
        <Container>
            <Header>
                <InfoWrapper>
                    <p>{formatBRLFromCents(valorFaturamento)}</p>
                    <h3>VALOR DO PEDIDO</h3>
                </InfoWrapper>
                <InfoWrapper>
                    <p>{formatBRLFromCents(valorTotalBM)}</p>
                    <h3>VALOR TOTAL DE BM</h3>
                </InfoWrapper>
                <InfoWrapper>
                    <p>{formatBRLFromCents(valorADistribuir)}</p>
                    <h3>VALOR SALDO DO PEDIDO</h3>
                </InfoWrapper>
                <InfoWrapper>
                    <p>{formatBRLFromCents(saldoPrevisao)}</p>
                    <h3>SALDO PREVISÃO</h3>
                </InfoWrapper>
            </Header>
            <TabelaWrapper>
                {
                    loading ? (
                        <LoadingWrapper>
                            <LoadingContainer>
                                <SmallLoading />
                            </LoadingContainer>
                        </LoadingWrapper>
                    ) : (
                        <Tabela>
                            <thead>
                                <LinhaCabecalho>
                                    <ColunaCabecalho colSpan={3} >
                                        PREVISÃO DE FATURAMENTO PEDIDO DE COMPRA: {numPedido}
                                    </ColunaCabecalho>
                                    <ColunaCabecalho width="90px" >
                                        <EditButton
                                            onClick={handleStartEditing}
                                            disabled={isEditing}
                                        >
                                            {isEditing ? "EDITANDO" : "EDITAR"}
                                        </EditButton>
                                    </ColunaCabecalho>
                                </LinhaCabecalho>
                                <LinhaCabecalho>
                                    <ColunaCabecalho>Nº BM</ColunaCabecalho>
                                    <ColunaCabecalho>DATA</ColunaCabecalho>
                                    <ColunaCabecalho>VALOR DE MEDIÇÃO</ColunaCabecalho>
                                    <ColunaCabecalho />
                                </LinhaCabecalho>
                            </thead>
                            <tbody>
                                {
                                    boletins.map((item) => (
                                        <tr key={item.id || item.idTemp}>
                                            <td>
                                                <CellInput
                                                    type="text"
                                                    value={item.num_bm}
                                                    onChange={(e) => handleChange(e, item.id || item.idTemp)}
                                                    name="num_bm"
                                                    disabled={!isEditing}
                                                />
                                            </td>
                                            <td>
                                                <CellInput
                                                    type="date"
                                                    value={item.data}
                                                    onChange={(e) => handleChange(e, item.id || item.idTemp)}
                                                    name="data"
                                                    disabled={!isEditing}
                                                />
                                            </td>
                                            <TdInput>
                                                <CellInput
                                                    type="text"
                                                    value={formatBRLFromCents(item.valor_medicao)}
                                                    onChange={(e) => handleChange(e, item.id || item.idTemp)}
                                                    name="valor_medicao"
                                                    disabled={!isEditing}
                                                />
                                            </TdInput>
                                            <td>
                                                <IconeWrapper>
                                                    {
                                                        isEditing && (
                                                            <Lixeira
                                                                onClick={() => handleDelete(item.id || item.idTemp)}
                                                            />
                                                        )
                                                    }
                                                </IconeWrapper>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Tabela>
                    )
                }
            </TabelaWrapper>
            <ActionWrapper>
                <AddButton
                    onClick={handleAddBoletim}
                    disabled={saving}
                >
                    ACRESCENTAR PREVISÃO
                </AddButton>
                <ActionButton
                    // Botão de cancelar fica desabilitado se não estiver editando.
                    disabled={!isEditing || saving}
                    onClick={handleCancel}
                >CANCELAR</ActionButton>
                <ActionButton
                    disabled={!isDirty || !canSave || saving}
                    onClick={handleSave}
                >
                    {saving ? "SALVANDO..." : "SALVAR"}
                </ActionButton>
            </ActionWrapper>
            {
                BMPendingWarningVisible && (
                    <Overlay state={true} >
                        <BMPendingWarning className={btnConfirmLeaving ? "fade-out" : ""} >
                            <BMPendingWarningIconWrapper>
                                <BMPendingWarningIcon />
                            </BMPendingWarningIconWrapper>
                            <h3>AVISO!</h3>
                            <p>Somente após a atualização do Saldo de Previsão de Faturamento o BM será salvo no sistema.</p>
                            <BMPendingWarningButton onClick={confirmPendingBM} >
                                ENTENDI
                            </BMPendingWarningButton>
                        </BMPendingWarning>
                    </Overlay>
                )
            }
        </Container>
    )
}

export default BodyWrapper;